var map = {
	"../companies-admin/companies-admin.module": [
		"./src/app/companies-admin/companies-admin.module.ts"
	],
	"../manage-reports/manage-reports.module": [
		"./src/app/manage-reports/manage-reports.module.ts",
		"manage-reports.module"
	],
	"../users/users.module": [
		"./src/app/users/users.module.ts"
	],
	"./system-overview/system-overview.module": [
		"./src/app/admin/system-overview/system-overview.module.ts",
		"system-overview.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_lazy_route_resource lazy
// module id = ./src/$$_lazy_route_resource lazy recursive
// module chunks = main